import { swipeBehavior } from "@tma.js/sdk-react"
import { useEffect } from "react"

export function useDisableTmaSwipes() {
	useEffect(() => {
		try {
			if (!swipeBehavior.isSupported()) return
			if (!swipeBehavior.isMounted()) swipeBehavior.mount()
			swipeBehavior.disableVertical()
		} catch {
			return
		}
		return () => {
			try {
				swipeBehavior.enableVertical()
			} catch {}
		}
	}, [])
}
